import { ThemeSSRManager } from '../src/ThemeSSRManager';

export const themeSSRManager = new ThemeSSRManager();
